<template>
    <div>
        <div class="container-fluid fixcontent" :class="(savingPayment || savingAdjustment) ? 'disable-page' : ''">

            <!-- Header Section -->
            <div class="row" style="margin-top: 1px; margin-bottom: -4px !important;">
                <div class="col-md-2 text-light" style="padding-left: 0px !important;">
                    <b-link :to="{ path: '/' }">
                        <img class="col-md-12" src="@/assets/images/headerlogo.png" alt="Logo">
                    </b-link>
                </div>
                <div class="col-md-6 text-center col-7 mt-4 mtmb text-light offset-1 font-weight-semi-bold" style="font-size: 17px">
                    <welcomenote/>
                </div>
                <div class="col-md-3 text-right col-4 text-light mt-1 mtmb" style="font-size: 17px">
                    <p style="margin-bottom: 0.3rem"><ShowRealTime/></p>
                    <a class="text-light" href="#" @click.prevent="signOut">Login</a> /
                    <a class="text-light" href="#" @click.prevent="signOut">Logout</a>
                </div>
            </div>

            <!-- Main Content Area -->
            <div class="row mt-2">
                <sidebar></sidebar>

                <div class="col-md-11">
                    <div class="row mb-1">
                        <h1 class="col-md-12 text-center text-light font-weight-bold">Franchisee Bill Details</h1>
                    </div>

                    <div class="row mt-1" v-if="loading">
                        <div class="col-md-10 offset-1 text-center">
                            <loader/>
                        </div>
                    </div>

                    <div v-if="!loading && bill">

                        <!-- Items Table Section -->
                        <div class="row mb-2">
                            <div class="col-md-12 col-12">
                                <div class="bgsecond fixheight border border-secondary shadow-sm">
                                    <!-- Desktop Table -->
                                    <table class="table table-responsive-sm d-none d-md-table mb-0">
                                        <thead class="thead-dark table-bordered">
                                        <tr>
                                            <th scope="col" style="width: 20%;">Code</th>
                                            <th scope="col">Description</th>
                                            <th scope="col" style="width: 10%;" class="text-center">Qty</th>
                                            <th scope="col" style="width: 15%;" class="text-right">Unit Price</th>
                                            <th scope="col" style="width: 15%;" class="text-right">Total</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr class="text-light" v-for="item in billItems" :key="item.id">
                                            <th scope="row" class="align-middle">{{ item.itemCode }}</th>
                                            <td class="align-middle">{{ item.itemDescription }}</td>
                                            <td class="align-middle text-center">{{ item.quantity }}</td>
                                            <td class="align-middle text-right">£{{ Number(item.unitPrice).toFixed(2) }}</td>
                                            <td class="align-middle text-right font-weight-bold">£{{ Number(item.subtotal).toFixed(2) }}</td>
                                        </tr>
                                        <tr v-if="!billItems.length">
                                            <td colspan="5" class="text-center text-muted py-3">No items found in this bill.</td>
                                        </tr>
                                        </tbody>
                                    </table>

                                    <!-- Mobile Table -->
                                    <table class="table table-responsive-sm d-block d-md-none mb-0" style="table-layout: fixed; width: 100%;">
                                        <thead class="thead-dark table-bordered">
                                        <tr>
                                            <th scope="col">Code</th>
                                            <th scope="col">Description</th>
                                            <th scope="col" class="text-center">Qty</th>
                                            <th scope="col" class="text-right">Unit Price</th>
                                            <th scope="col" class="text-right">Total</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr class="text-light" v-for="item in billItems" :key="item.id">
                                            <td>{{ item.itemCode }}</td>
                                            <td>{{ item.itemDescription }}</td>
                                            <td class="text-center">{{ item.quantity }}</td>
                                            <td class="text-right">£{{ Number(item.unitPrice).toFixed(2) }}</td>
                                            <td class="text-right font-weight-bold">£{{ Number(item.subtotal).toFixed(2) }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <!-- Details & Payments Section -->
                        <div class="row">

                            <!-- Left Column: Adjustment & Franchise Details -->
                            <div class="col-md-6 d-flex flex-column">

                                <!-- Adjustment Panel -->
                                <div class="Border bgsecond p-3 text-light mx-0 mb-3 shadow-sm rounded">
                                    <h4 class="heading w-100 border-bottom border-secondary pb-2 mb-3">Adjustment</h4>
                                    <div class="row align-items-end">
                                        <div class="col-md-5 px-2 mb-2 mb-md-0">
                                            <label class="mb-1 text-muted font-weight-bold" style="font-size: 14px;">Description</label>
                                            <input type="text" class="form-control bg-light text-dark"  v-model="adjustment.itemDescription">
                                        </div>
                                        <div class="col-md-2 px-2 mb-2 mb-md-0">
                                            <label class="mb-1 text-muted font-weight-bold" style="font-size: 14px;">Unit Price</label>
                                            <input type="number" class="form-control bg-light text-dark" step="any" v-model="adjustment.unitPrice">
                                        </div>
                                        <div class="col-md-1 px-2 mb-2 mb-md-0">
                                            <label class="mb-1 text-muted font-weight-bold" style="font-size: 14px;">Quantity</label>
                                            <input type="number" class="form-control bg-light text-dark" step="any" v-model="adjustment.quantity">
                                        </div>
                                        <div class="col-md-2 px-2 mb-2 mb-md-0">
                                            <label class="mb-1 text-muted font-weight-bold" style="font-size: 14px;">Subtotal</label>
                                            <input type="number" class="form-control bg-secondary text-white border-0" :value="(adjustment.unitPrice * adjustment.quantity).toFixed(2)" disabled>
                                        </div>
                                        <div class="col-md-2 px-2 mt-2 mt-md-0">
                                            <button class="btn btn-info w-100 font-weight-bold" @click="updateAdjustment" :disabled="savingAdjustment">
                                                <span v-if="savingAdjustment"><i class="bi bi-hourglass-split"></i></span>
                                                <span v-else>Update</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Franchise Details Panel -->
                                <div class="Border bgsecond p-3 text-light mx-0 shadow-sm rounded flex-grow-1">
                                    <h4 class="heading w-100 border-bottom border-secondary pb-2 mb-3">Franchise Details</h4>
                                    <div class="row" v-if="bill.franchisee">
                                        <div class="col-md-12">
                                            <table class="table table-borderless text-light table-sm mb-0">
                                                <tbody>
                                                <tr><th class="w-50 text-muted">Name:</th><td>{{ bill.franchisee.f_name }}</td></tr>
                                                <tr><th class="text-muted">Legal Company:</th><td>{{ bill.franchisee.f_legalCompanyName }}</td></tr>
                                                <tr><th class="text-muted">Branch (Invoice):</th><td>{{ bill.franchisee.f_branchNameInvoice }}</td></tr>
                                                <tr><th class="text-muted">Royalties %:</th><td>{{ bill.franchisee.f_royalities_percentage }}%</td></tr>
                                                <tr><th class="text-muted">Cost Margin %:</th><td>{{ bill.franchisee.f_costMarginPercent }}%</td></tr>
                                                <tr><th class="text-muted">Shipping Margin %:</th><td>{{ bill.franchisee.f_shippingMarginPercent }}%</td></tr>
                                                <tr><th class="text-muted">Collection Fix Rate:</th><td>£{{ bill.franchisee.f_collectionFixRate }}</td></tr>
                                                <tr><th class="text-muted">Due Days:</th><td>{{ bill.franchisee.f_dueDays }} Days</td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div v-else class="text-muted text-center mt-3">
                                        Franchisee details not available.
                                    </div>
                                </div>
                            </div>

                            <!-- Right Column: Summary & Payment -->
                            <div class="col-md-6 d-flex flex-column">

                                <!-- Bill Summary -->
                                <div class="Border1 bgsecond p-3 text-light font-weight-semi-bold lg1 mx-0 mb-3 shadow-sm rounded" style="font-size: 17px;">
                                    <div class="row">
                                        <div class="col-md-6 px-3 border-right border-secondary">
                                            <div class="d-flex justify-content-between mb-2">
                                                <span class="HDcolor">Bill Ref#:</span>
                                                <span>{{ bill.bill_ref }}</span>
                                            </div>
                                            <div class="d-flex justify-content-between mb-2">
                                                <span class="HDcolor">Due Date:</span>
                                                <span>{{ formatDate(bill.dueDate) }}</span>
                                            </div>
                                            <div class="d-flex justify-content-between mb-2">
                                                <span class="HDcolor font-color">Status:</span>
                                                <span :class="{'text-warning': bill.status === 'Pending', 'text-success': bill.status === 'Paid'}">{{ bill.status }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6 px-3">
                                            <div class="d-flex justify-content-between mb-1">
                                                <span class="text-muted">Sub Total:</span>
                                                <span>£{{ Number(bill.subTotal).toFixed(2) }}</span>
                                            </div>
                                            <div class="d-flex justify-content-between mb-1">
                                                <span class="text-muted">VAT:</span>
                                                <span>£{{ Number(bill.vat).toFixed(2) }}</span>
                                            </div>
                                            <div class="d-flex justify-content-between border-bottom border-secondary pb-1 mb-1">
                                                <span class="text-muted">Grand Total:</span>
                                                <span>£{{ Number(bill.grandTotal).toFixed(2) }}</span>
                                            </div>
                                            <div class="d-flex justify-content-between mb-1">
                                                <span class="font-color font-weight-bold">Total:</span>
                                                <span class="font-weight-bold">£{{ Number(bill.grandTotal).toFixed(2) }}</span>
                                            </div>
                                            <div class="d-flex justify-content-between mb-1">
                                                <span class="HDcolor">Paid:</span>
                                                <span class="text-success">£{{ Number(bill.totalPaid).toFixed(2) }}</span>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <span class="font1-color font-weight-bold">Due:</span>
                                                <span class="text-danger font-weight-bold">£{{ due.toFixed(2) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Payment Interface -->
                                <div class="Border bgsecond p-3 text-light mx-0 shadow-sm rounded flex-grow-1">
                                    <h4 class="heading w-100 border-bottom border-secondary pb-2 mb-3">Enter New Payment</h4>

                                    <div class="row mb-3">
                                        <div class="col-md-4 px-2 mb-2 mb-md-0">
                                            <label class="mb-1 text-muted font-weight-bold" style="font-size: 14px;">Payment Type</label>
                                            <v-select
                                                v-model="payment.payment_type"
                                                class="bg-light text-dark rounded"
                                                placeholder="Choose Type"
                                                :options="paymentTypes"
                                            />
                                        </div>
                                        <div class="col-md-3 px-2 mb-2 mb-md-0">
                                            <label class="mb-1 text-muted font-weight-bold" style="font-size: 14px;">Amount</label>
                                            <div class="input-group">
                                                <div class="input-group-prepend"><span class="input-group-text bg-dark text-light border-secondary">£</span></div>
                                                <input class="form-control bg-light text-dark" type="number" step="any" v-model="payment.payment_amount" placeholder="0.00">
                                            </div>
                                        </div>
                                        <div class="col-md-3 px-2 mb-2 mb-md-0">
                                            <label class="mb-1 text-muted font-weight-bold" style="font-size: 14px;">Ref Number</label>
                                            <input type="text" class="form-control bg-light text-dark" placeholder="Reference No." v-model="payment.reference">
                                        </div>
                                        <div class="col-md-2 px-2">
                                            <label class="mb-1 text-muted font-weight-bold" style="font-size: 14px;">Date</label>
                                            <b-form-datepicker
                                                :reset-button="true"
                                                reset-button-variant="btn btn-warning"
                                                id="payment-datepicker"
                                                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                                v-model="payment.date"
                                                placeholder="Date"
                                                class="bg-light text-dark"
                                                dropup calendar-width="100%">
                                            </b-form-datepicker>
                                        </div>
                                    </div>

                                    <div class="row mb-3">
                                        <div class="col-md-12 px-2">
                                            <div class="d-flex justify-content-around align-items-center bg-dark border border-secondary p-2 rounded shadow-inner">
                                                <div class="text-light"><strong>Total:</strong> £{{ Number(bill.grandTotal).toFixed(2) }}</div>
                                                <div class="text-success"><strong>Paid:</strong> £{{ Number(bill.totalPaid).toFixed(2) }}</div>
                                                <div class="text-danger font-weight-bold" style="font-size: 1.1em;"><strong>Due Balance:</strong> £{{ due.toFixed(2) }}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-4">
                                        <div class="col-md-12 px-2 text-right">
                                            <button class="btn btn-success custom-btn2 font-weight-bold px-4" @click="savePayment" :disabled="savingPayment || !payment.payment_type || !payment.payment_amount || payment.payment_amount==0 || !payment.reference || payment.payment_amount>due ">
                                                <span v-if="savingPayment"><i class="bi bi-hourglass-split"></i> Saving...</span>
                                                <span v-else><i class="bi bi-cash-stack mr-1"></i> Add Payment</span>
                                            </button>
                                        </div>
                                    </div>

                                    <h4 class="heading w-100 border-bottom border-secondary pb-2 mb-3">Payment History</h4>
                                    <div class="payment-height2 w-100" :class="bill.payments && bill.payments.length ? 'payment-height' : ''">
                                        <table class="table table-bordered table-sm text-light table-striped mb-0" v-if="bill.payments && bill.payments.length">
                                            <thead class="thead-dark">
                                            <tr>
                                                <th>Date</th>
                                                <th>Type</th>
                                                <th class="text-right">Amount</th>
                                                <th>Reference #</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="pmt in bill.payments" :key="pmt.id">
                                                <td class="align-middle">{{ formatDate(pmt.date) }}</td>
                                                <td class="align-middle">
                                                    <span class="badge badge-secondary p-1">{{ pmt.payment_type }}</span>
                                                </td>
                                                <td class="align-middle text-right font-weight-bold text-success">£{{ Number(pmt.payment_amount).toFixed(2) }}</td>
                                                <td class="align-middle">{{ pmt.reference || 'N/A' }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        <div v-else class="text-center text-muted py-4 border border-secondary rounded bg-dark">
                                            <i class="bi bi-info-circle mb-2" style="font-size: 1.5rem;"></i><br>
                                            No payments recorded yet.
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import sidebar from "@/components/layout/sidebar";
import showrealtime from "@/components/showrealtime";
import Welcomenote from "@/pages/admin/mypos/welcomenote.vue";
import URL from "@/constants/baseurl";
import Loader from "@/components/loader.vue";
import Swal from "sweetalert2";
import axios from "axios";
import moment from "moment/moment";
import vSelect from "vue-select";

export default {
    name: "franchisee bill details",

    components:{Loader, Welcomenote, 'sidebar': sidebar,'ShowRealTime':showrealtime, 'v-select': vSelect},
    computed: {
        authenticatedUser() {
            let user = localStorage.getItem('user');
            user = JSON.parse(user)
            return user
        },
        due() {
            if (!this.bill) return 0;
            return Number(this.bill.grandTotal) - Number(this.bill.totalPaid);
        },
        billItems() {
            if (!this.bill || !this.bill.items) return [];
            return this.bill.items.filter(item => item.itemCode !== 'ADJUSTMENT');
        },
    },
    data() {
        return {
            loading: false,
            savingPayment: false,
            savingAdjustment: false,
            bill: null,
            payment: {
                payment_type: '',
                payment_amount: 0,
                reference: '',
                date: '',
            },
            adjustment: {
                unitPrice: 0,
                quantity: 1,
            },
            paymentTypes: [
                'Cash',
                'Card',
                'Bank',
                'Pay By Link',
            ],
        };
    },
    async created() {
        const billId = this.$route.query.id;
        if (billId) {
            await this.loadBill(billId);
        }
    },
    methods: {
        ...mapActions(['processLogoutManual']),

        formatDate(date){
            if (!date) return '';
            let date1 = new Date(date)
            return moment(date1).format('D MMMM, YYYY');
        },

        async loadBill(id) {
            this.loading = true;
            const apiToken = localStorage.getItem('token');
            try {
                const response = await fetch(`${URL.BASEURL}/api/get-franchisee-bill/${id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiToken}`
                    },
                });
                if (response.ok) {
                    const res = await response.json();
                    this.bill = res;
                    const adj = res.items.find(i => i.itemCode === 'ADJUSTMENT');
                    if (adj) {
                        this.adjustment.unitPrice = Number(adj.unitPrice);
                        this.adjustment.quantity = Number(adj.quantity);
                        this.adjustment.itemDescription = adj.itemDescription;
                    }
                } else {
                    Swal.fire('Error', 'Bill not found', 'error');
                }
            } catch (error) {
                console.error('Error fetching bill:', error);
            }
            this.loading = false;
        },

        async savePayment() {
            if (!this.payment.payment_type || !this.payment.payment_amount || this.payment.payment_amount == 0) {
                Swal.fire('Info', 'Please fill payment type and amount', 'info');
                return;
            }

            this.savingPayment = true;
            const apiToken = localStorage.getItem('token');
            if (apiToken) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
            }

            try {
                const res = await axios.post(`${URL.BASEURL}/api/create-franchisee-bill-payment`, {
                    franchisee_bill_id: this.bill.id,
                    payment_type: this.payment.payment_type,
                    payment_amount: this.payment.payment_amount,
                    reference: this.payment.reference,
                    date: this.payment.date || null,
                });

                if (res.data) {
                    this.bill = res.data;
                    this.payment = {
                        payment_type: '',
                        payment_amount: 0,
                        reference: '',
                        date: '',
                    };
                    const adj = this.bill.items.find(i => i.itemCode === 'ADJUSTMENT');
                    if (adj) {
                        this.adjustment.unitPrice = Number(adj.unitPrice);
                        this.adjustment.quantity = Number(adj.quantity);
                        this.adjustment.itemDescription = adj.itemDescription;
                    } else {
                        this.adjustment.unitPrice = 0;
                        this.adjustment.quantity = 1;
                    }
                    Swal.fire('Success', 'Payment saved successfully!', 'success');
                }
            } catch (error) {
                console.error('Error saving payment:', error);
                Swal.fire('Error', 'Failed to save payment.', 'error');
            }
            this.savingPayment = false;
        },

        async updateAdjustment() {
            this.savingAdjustment = true;
            const apiToken = localStorage.getItem('token');
            if (apiToken) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
            }

            try {
                const res = await axios.post(`${URL.BASEURL}/api/update-franchisee-bill-adjustment/${this.bill.id}`, {
                    unitPrice: this.adjustment.unitPrice,
                    quantity: this.adjustment.quantity,
                    itemDescription: this.adjustment.itemDescription,
                });

                if (res.data) {
                    this.bill = res.data;
                    const adj = this.bill.items.find(i => i.itemCode === 'ADJUSTMENT');
                    if (adj) {
                        this.adjustment.unitPrice = Number(adj.unitPrice);
                        this.adjustment.quantity = Number(adj.quantity);
                        this.adjustment.itemDescription = adj.itemDescription;
                    } else {
                        this.adjustment.unitPrice = 0;
                        this.adjustment.quantity = 1;
                    }
                    Swal.fire('Success', 'Adjustment updated successfully!', 'success');
                }
            } catch (error) {
                console.error('Error updating adjustment:', error);
                Swal.fire('Error', 'Failed to update adjustment.', 'error');
            }
            this.savingAdjustment = false;
        },

        async signOut() {
            await this.processLogoutManual();
            window.location.href = this.$router.resolve({ name: "Login" }).href;
        },
    },
}
</script>

<style scoped>
@import '../../../assets/styles/pos.css';

.hide {
    visibility: hidden !important;
}

.payment-height {
    max-height: 250px;
    overflow-y: auto;
}

.payment-height2 {
    min-height: 150px;
}

.disable-page {
    pointer-events: none;
    opacity: 0.8;
}

/* Custom enhancements for data density and matching dark POS theme */
.shadow-inner {
    box-shadow: inset 0 1px 3px rgba(0,0,0,0.5);
}

.bgsecond {
    background-color: var(--secondary-bg-color, #1e1e2d); /* Adjust if predefined in pos.css */
}

.table-sm th, .table-sm td {
    padding: 0.4rem;
}

.heading {
    color: var(--heading-color, #f8f9fa);
}
</style>
